import PropTypes from "prop-types";
import DashboardPuiProjectTracker from "./dashboard-pui-project-tracker";
import DashboardPuiMemberTracker from "./dashboard-pui-member-tracker";

const DashboardPowerStaffer = (props) => {
    return (
        <div>
            {props?.powerStafferProjectAndMemberTrackerItems && <DashboardPuiMemberTracker members={props?.powerStafferProjectAndMemberTrackerItems?.Members} />}
            <div className="mb-4" />
            {props?.powerStafferProjectAndMemberTrackerItems && <DashboardPuiProjectTracker projects={props?.powerStafferProjectAndMemberTrackerItems?.Projects} members={props?.powerStafferProjectAndMemberTrackerItems?.Members} />}
        </div>
    );
};

DashboardPowerStaffer.propTypes = {
    powerStafferProjectAndMemberTrackerItems: PropTypes.object,
};

export default DashboardPowerStaffer;